import { render } from "./TabPlantDetailsControlBMSForm.vue?vue&type=template&id=788fc928&scoped=true"
import script from "./TabPlantDetailsControlBMSForm.vue?vue&type=script&lang=js"
export * from "./TabPlantDetailsControlBMSForm.vue?vue&type=script&lang=js"

import "./TabPlantDetailsControlBMSForm.vue?vue&type=style&index=0&id=788fc928&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-788fc928"]])

export default __exports__